import React, { PureComponent } from "react";
import Gap from "@zendesk/knowledge-components/lib/Gap";
import FrequencyField from "components/FrequencyField";
import RuleNameField from "components/RuleNameField";
import validateRuleName from "state/validateRuleName";
import { Mutation, Query } from "react-apollo";
import gql from "graphql-tag";
import { updateDirtyStateMutation } from "mutations/updateDirtyStateMutation";

export const frequencyStepQuery = gql`
  query FrequencyStep {
    wizard @client {
      showValidation
    }
    dirtyState @client {
      ruleName
      frequency
    }
  }
`;

class FrequencyStep extends PureComponent {
  render() {
    return (
      <Query query={frequencyStepQuery}>
        {({ data: { dirtyState, wizard } }) => (
          <Mutation mutation={updateDirtyStateMutation}>
            {mutate => (
              <div>
                <RuleNameField
                  value={dirtyState.ruleName}
                  onChange={event =>
                    mutate({
                      variables: { data: { ruleName: event.target.value } },
                    })
                  }
                  showValidation={
                    wizard.showValidation &&
                    !validateRuleName(dirtyState.ruleName)
                  }
                />
                <Gap.Huge vertical />
                <FrequencyField
                  selectedKey={dirtyState.frequency}
                  onChange={key =>
                    mutate({ variables: { data: { frequency: key } } })
                  }
                />
              </div>
            )}
          </Mutation>
        )}
      </Query>
    );
  }
}

export default FrequencyStep;



// WEBPACK FOOTER //
// ./src/components/FrequencyStep/index.js